import { createAsyncSlice } from 'store/createAsyncSlice';
import { deleteAchPushAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: deleteAchPushSlice, asyncAction: deleteAchPushAction } = createAsyncSlice(
  'deleteAchPushSlice',
  deleteAchPushAsync
);
